import React from "react";
import { Routes, Route } from "react-router-dom";

import FollowupPage from "../pages/FollowupPage";
import FollowupDetailPage from "../pages/FollowupDetailPage";
import FMSDashboard from "../pages/FMSDashboard";

import RuleManagementPage from "../automation/pages/RuleManagementPage";

export default function FmsRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<FMSDashboard />} />
      <Route path="/followups" element={<FollowupPage />} />
      <Route path="/followups/:id" element={<FollowupDetailPage />} />

      <Route path="/rules" element={<RuleManagementPage />} />
    </Routes>
  );
}
